import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { authErrorKeys } from 'src/app/util/auth-error.util';

/**
 * Requests a password-reset link.
 *
 * The server answers identically whether or not the address is known, and this
 * page must not undo that: on ANY successful response it shows the same
 * confirmation. Branching the UI on the result -- or on how long the request took
 * -- would turn a deliberately uniform endpoint back into an account directory.
 *
 * The only errors surfaced are transport-level ones (offline, rate-limited),
 * which say nothing about whether the account exists.
 */
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['../auth-shell.css'],
    standalone: false
})
export class ForgotPasswordComponent {
  username = '';
  busy = false;
  sent = false;
  errorKeys: string[] = [];

  constructor(private auth: AuthService) {}

  submit() {
    if (!this.username || this.busy) return;
    this.busy = true;
    this.errorKeys = [];
    this.auth.forgotPassword(this.username).subscribe({
      next: () => { this.busy = false; this.sent = true; },
      error: (err) => { this.busy = false; this.errorKeys = authErrorKeys(err); }
    });
  }
}
